/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a572248445144cfc82d4efcd3aad9d2bea6bd204";
